(function () {
  let affirmCountryKeys = {
    US: "PDYZVJHUCX8MPK34",
    CA: "PDYZVJHUCX8MPK34",
  };

  let affirmCheckoutPath = "/checkout?skip_shop_pay=true";
  let boundAttribute = "data-affirm-direct-checkout-bound";
  let variantBoundAttribute = "data-affirm-variant-change-bound";

  function getAffirmCountry() {
    if (!window.Shopify || !window.Shopify.country) {
      return null;
    }

    if (!affirmCountryKeys[window.Shopify.country]) {
      return null;
    }

    return window.Shopify.country;
  }

  function showAffirmWrappers() {
    document
      .querySelectorAll(
        "[data-affirm-product-wrapper], [data-affirm-cart-wrapper]",
      )
      .forEach(function (wrapper) {
        wrapper.hidden = false;
      });
  }

  function hideAffirmWrappers() {
    document
      .querySelectorAll(
        "[data-affirm-product-wrapper], [data-affirm-cart-wrapper]",
      )
      .forEach(function (wrapper) {
        wrapper.hidden = true;
      });
  }

  function getProductForm(button) {
    return button.closest("form");
  }

  function getAddToCartButton(form) {
    if (!form) {
      return null;
    }

    return form.querySelector("[data-add-to-cart]");
  }

  function getProductSection(form) {
    if (!form) {
      return null;
    }

    return form.closest(".product-section, product-hot-reload");
  }

  function syncProductButton(button, variant) {
    let form = getProductForm(button);
    let addToCartButton = getAddToCartButton(form);
    let label = button.querySelector(".affirm-direct-checkout__label");
    let isUnavailable = false;

    if (variant) {
      isUnavailable = !variant.available;
    } else if (addToCartButton) {
      isUnavailable = addToCartButton.disabled;
    }

    button.disabled = isUnavailable;

    if (!label) {
      return;
    }

    label.textContent = isUnavailable
      ? "Affirm unavailable"
      : "Buy with Affirm";
  }

  function serializeForm(form) {
    let values = [];

    form.querySelectorAll("input, select, textarea").forEach(function (field) {
      if (!field.name || field.disabled) {
        return;
      }

      if (
        (field.type === "checkbox" || field.type === "radio") &&
        !field.checked
      ) {
        return;
      }

      if (field.tagName === "SELECT" && field.multiple) {
        Array.prototype.slice.call(field.options).forEach(function (option) {
          if (!option.selected) {
            return;
          }

          values.push(
            encodeURIComponent(field.name) +
              "=" +
              encodeURIComponent(option.value),
          );
        });

        return;
      }

      values.push(
        encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value),
      );
    });

    return values.join("&");
  }

  function setButtonLoading(button, isLoading) {
    button.disabled = isLoading;
    button.classList.toggle("btn--loading", isLoading);
  }

  function goToCheckout() {
    window.location.href = affirmCheckoutPath;
  }

  function getTermsAcceptance() {
    if (!window.theme || !window.theme.termsAcceptance) {
      return null;
    }

    return window.theme.termsAcceptance;
  }

  function captureAffirmCheckoutDiagnostic(action, button, event, level) {
    let termsAcceptance = getTermsAcceptance();

    if (
      !termsAcceptance ||
      typeof termsAcceptance.captureCheckoutDiagnostic !== "function"
    ) {
      return;
    }

    termsAcceptance.captureCheckoutDiagnostic(action, {
      checkoutMethod: "affirm_direct",
      container: button,
      eventType: event ? event.type : "",
      level: level || "info",
      termsRequired: button.dataset.termsRequired === "true",
    });
  }

  function blockAffirmCheckoutWhenTermsUnavailable(button, event) {
    captureAffirmCheckoutDiagnostic(
      "affirm_checkout_gate_unavailable",
      button,
      event,
      "warning",
    );
    setButtonLoading(button, false);
    syncProductButton(button);

    if (
      window.theme &&
      window.theme.strings &&
      window.theme.strings.termsEsignSaveError
    ) {
      window.alert(window.theme.strings.termsEsignSaveError);
      return;
    }

    window.alert("Please wait for terms to load, then try again.");
  }

  function proceedToAffirmCheckout(button, runCheckoutStep) {
    let termsAcceptance = getTermsAcceptance();

    if (
      button.dataset.termsRequired !== "true" ||
      !termsAcceptance ||
      typeof termsAcceptance.ensureCartSignatureHydrated !== "function"
    ) {
      runCheckoutStep();
      return;
    }

    termsAcceptance.ensureCartSignatureHydrated().then(function (hydrated) {
      if (!hydrated) {
        blockAffirmCheckoutWhenTermsUnavailable(button, null);
        return;
      }

      runCheckoutStep();
    });
  }

  function runAffirmCheckoutWithTerms(button, event, runCheckout) {
    if (button.dataset.termsRequired !== "true") {
      captureAffirmCheckoutDiagnostic(
        "affirm_checkout_ungated",
        button,
        event,
        "info",
      );
      runCheckout();
      return true;
    }

    let termsAcceptance = getTermsAcceptance();

    if (
      !termsAcceptance ||
      typeof termsAcceptance.ensureSignedBeforeAction !== "function"
    ) {
      return false;
    }

    if (
      typeof termsAcceptance.isSigned === "function" &&
      termsAcceptance.isSigned()
    ) {
      captureAffirmCheckoutDiagnostic(
        "affirm_checkout_signed",
        button,
        event,
        "info",
      );
      termsAcceptance.ensureSignedBeforeAction(function () {
        runCheckout();
      });
      return true;
    }

    captureAffirmCheckoutDiagnostic(
      "affirm_checkout_gate_blocked",
      button,
      event,
      "info",
    );
    termsAcceptance.ensureSignedBeforeAction(function () {
      captureAffirmCheckoutDiagnostic(
        "affirm_checkout_gate_resumed",
        button,
        null,
        "info",
      );
      runCheckout();
    });
    return true;
  }

  function submitProductToCheckout(button) {
    let form = getProductForm(button);

    if (!form) {
      return;
    }

    let addToCartButton = getAddToCartButton(form);

    if (addToCartButton && addToCartButton.disabled) {
      syncProductButton(button);
      return;
    }

    setButtonLoading(button, true);

    fetch(window.theme.routes.cartAdd, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: serializeForm(form),
    })
      .then(function (response) {
        if (!response.ok) {
          throw response;
        }

        proceedToAffirmCheckout(button, goToCheckout);
        return null;
      })
      .catch(function () {
        setButtonLoading(button, false);
        syncProductButton(button);
      });
  }

  function termsAccepted(button) {
    if (!button || button.dataset.termsRequired !== "true") {
      return true;
    }

    let form = button.closest("form");

    if (!form) {
      return true;
    }

    let termsCheckbox = form.querySelector(".cart__terms-checkbox");

    if (!termsCheckbox) {
      return true;
    }

    if (termsCheckbox.checked) {
      return true;
    }

    if (
      window.theme &&
      window.theme.strings &&
      window.theme.strings.cartTermsConfirmation
    ) {
      window.alert(window.theme.strings.cartTermsConfirmation);
    }

    termsCheckbox.focus();
    return false;
  }

  function handleAffirmCheckout(button, event) {
    if (event && event.type === "touchend") {
      event.preventDefault();
    }

    if (
      runAffirmCheckoutWithTerms(button, event, function () {
        submitProductToCheckout(button);
      })
    ) {
      return;
    }

    if (button.dataset.termsRequired === "true") {
      blockAffirmCheckoutWhenTermsUnavailable(button, event);
      return;
    }

    submitProductToCheckout(button);
  }

  function handleAffirmCartCheckout(button, event) {
    if (event && event.type === "touchend") {
      event.preventDefault();
    }

    if (
      runAffirmCheckoutWithTerms(button, event, function () {
        runCartCheckout(button);
      })
    ) {
      return;
    }

    if (button.dataset.termsRequired === "true") {
      blockAffirmCheckoutWhenTermsUnavailable(button, event);
      return;
    }

    if (!termsAccepted(button)) {
      return;
    }

    runCartCheckout(button);
  }

  function bindAffirmButtonEvents(button, handleEvent) {
    if (button.getAttribute(boundAttribute) === "true") {
      return;
    }

    button.setAttribute(boundAttribute, "true");
    let touchHandled = false;

    button.addEventListener("touchend", function (event) {
      touchHandled = true;
      handleEvent(button, event);
      window.setTimeout(function () {
        touchHandled = false;
      }, 400);
    }, { passive: false });

    button.addEventListener("click", function (event) {
      if (touchHandled) {
        return;
      }

      handleEvent(button, event);
    });
  }

  function bindProductButtons() {
    document
      .querySelectorAll("[data-affirm-product-button]")
      .forEach(function (button) {
        syncProductButton(button);

        if (button.getAttribute(boundAttribute) === "true") {
          return;
        }

        bindAffirmButtonEvents(button, handleAffirmCheckout);

        let section = getProductSection(
          button.closest("[data-affirm-product-wrapper]"),
        );

        if (
          section &&
          section.getAttribute(variantBoundAttribute) !== "true"
        ) {
          section.setAttribute(variantBoundAttribute, "true");
          section.addEventListener("variantChange", function (event) {
            section
              .querySelectorAll("[data-affirm-product-button]")
              .forEach(function (sectionButton) {
                syncProductButton(sectionButton, event.detail.variant);
              });
          });
        }

        let form = getProductForm(button);

        if (form) {
          form.addEventListener("change", function () {
            window.setTimeout(function () {
              syncProductButton(button);
            }, 0);
          });
        }
      });
  }

  function runCartCheckout(button) {
    setButtonLoading(button, true);
    proceedToAffirmCheckout(button, goToCheckout);
  }

  function bindCartButtons() {
    document
      .querySelectorAll("[data-affirm-cart-button]")
      .forEach(function (button) {
        bindAffirmButtonEvents(button, handleAffirmCartCheckout);
      });
  }

  function init() {
    let country = getAffirmCountry();

    if (!country) {
      hideAffirmWrappers();
      return;
    }

    showAffirmWrappers();
    bindProductButtons();
    bindCartButtons();
  }

  window.initAffirmDirectCheckout = init;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
    return;
  }

  init();
})();
